import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import largeIcons from './large';

const Icon = ({ name, iconSize, className, children }) => {
    const RenderIcon = largeIcons[name];
    if (!RenderIcon) return children || null;

    return <RenderIcon className={classNames('Icon', name, className)} />;
};

Icon.propTypes = {
    name: PropTypes.string,
    iconSize: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.element,
};

export default Icon;
